const headerData = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "ContractStatusName", 
      label: "合同状态",
      columnwidth: 160,
    },
    {
      prop: "OpenAccountStatusName", 
      label: "开户状态",
      columnwidth: 160,
    },
    {
      prop: "CusName", 
      label: "经销商名称",
      columnwidth: 220,
    },
    {
      prop: "InvClassName",
      label: "产品线名称",
      columnwidth: 90,
    },
    {
      prop: "BuyFromHomeName",
      label: "是否从公司订购",
      columnwidth: 120,
    },
    {
      prop: "CompanyName",
      label: "上级公司名称",
      columnwidth: 120,
    },
    {
      prop: "czAll",
      label: "操作",
      columnwidth: 117,
      czAll: [
        {
          title: '上传',
          clickName: 'Upload',
          BtnFalg: true
        },
        {
          title: '下载',
          clickName: 'download',
          BtnFalg: true
        },
      ]
    },
    
  ];
  export default headerData
